import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  top: 10%;
  left: 32.5%;
  width: 35%;
  max-height: 80%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.32);
  overflow: auto;
  font-family: 'Roboto Slab', sans-serif;

  * {
    padding: 0;
    margin: 0;
  }

  .p-inputtext {
    position: relative;

    
    padding: 10px;

    width: 90%;
    height: 15px;

    margin: 5px 0 5px 0;
    text-align: left;
    background-color: #f1f1f2;

    border: 0;
    border-radius: 5px;
    font-size: 15px;
  }

  .p-password {
    left: 20%;
  }

  .p-inputwrapper {
    width: 60%;
  }

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    input,
    p {
      font-size: 14px;
    }
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    input,
    p {
      font-size: 13px;
    }
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    input,
    p {
      font-size: 12px;
    }
  }

  /* tablets na  vertical/celulares grandes */
  @media (max-width: 768px) {
    input,
    p {
      font-size: 11px;
    }
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    input,
    p {
      font-size: 9px;
    }
  }
`

export const Title = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 20px;
  padding: 8px 0 8px 0;
`

export const Logo = styled.img`
  position: relative;
  left: 50%;
  transform: translate(-50%, 0);
  margin: 21px 0 12px 0;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    width: 140px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    width: 120px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    width: 100px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    width: 90px;
    margin-top: 10px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    width: 80px;
    margin-top: 10px;
  }
`

export const CodeDiv = styled.div`
  position: relative;
  left: 20%;
  width: 60%;
  margin: 20px 0 0 0;
`

export const CountdownText = styled.p`
  margin: 10px 0 0 0;
  font-size: 11px;
`

export const GrayText = styled.span`
  color: #c2c2c2;
`

export const OtpInput = styled.input`
  position: relative;

  padding: 10px;

  left: 0%;
  width: 11%;
  height: 15px;

  margin: 5px 0 5px 0;
  margin-right: 5%;
  margin-top: 15px;

  text-align: center;
  background-color: #f1f1f2;

  border: 0;
  border-radius: 5px;
  font-size: 15px;
`

export const PassLabel = styled.label`
  position: relative;
  left: 20%;
  width: 60%;
  display: block;
  padding: 12px 0 10px 0;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 13px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 12px;
  }

  /* tablets na  vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 11px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 9px;
  }
`

export const InputButton = styled.input`
  position: relative;
  left: 20%;
  width: 60%;
  height: 40px;
  margin: 20px 0 20px 0;
  text-align: center;
  background-color: #6ec1e4;
  color: white;
  border: 0;
  border-radius: 5px;

  :hover {
    border: 1px black solid;
    cursor: pointer;
  }

  :active {
    background-color: #1f9dd4;
  }

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 13px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 12px;
  }

  /* tablets na  vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 11px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 9px;
  }
`
